import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Task } from '@app/interfaces/lm/kanban-board';

@Component({
  selector: 'app-task-detail-dialog',
  templateUrl: './task-detail-dialog.component.html',
  styleUrl: './task-detail-dialog.component.less'
})
export class TaskDetailDialogComponent {
    refreshStatus = false;
    @Output() closeEvent = new EventEmitter();
    @Output() refreshTask = new EventEmitter();
    detail: Task = {} as Task;
    isVisible = false;
    // 是否更新过task
    isUpdate = false;
    swimLaneIds: string[] = [];

    onRefreshStatus(event: any): void {
        if (event === 'refresh') {
            this.refreshStatus = true;
        }
    }
    open(task: Task): void {
        this.detail = { ...task };
        this.isVisible = true;
        this.isUpdate = false;
        this.swimLaneIds = [task.swimLaneId];
    }

    close(): void {
        this.isVisible = false;
        const swimLength = this.swimLaneIds.length;
        const changedSwimLane = swimLength > 1 && this.swimLaneIds[0] !== this.swimLaneIds[swimLength - 1];
        setTimeout(() => {
            this.refreshTask.emit(changedSwimLane ? {
                swimlaneId: this.swimLaneIds[swimLength - 1]
            } : null);
        }, 1000);
        if (this.refreshStatus) {
            this.closeEvent.emit('refresh');
        }
    }

    changeDetail(event:any): void {
        if(event.action === 'delete') {
            setTimeout(() => {
                this.refreshTask.emit({swimlaneId:event.swimLaneId});
            }, 1000);
        }
        this.isUpdate = true;
    }

    changeSwimLane(data: any): void {
        this.swimLaneIds.push(data?.swimLaneId);
        this.isUpdate = true;
    }
}
